<template>
    <div class="collected">
        <div class="search_item">
            <div class="search_main">
                <div class="search">
                    <IN v-if="!isPhone" v-model="source.artworkTitle" :placeholder="langJson('Search Art')"></IN>
                    <Search v-if="isPhone" v-model="source.artworkTitle"></Search>
                </div>
                <div class="sort">
                    <Sel :showBorder="true" v-model="source.orderByColumn" :list="sortlist"></Sel>
                </div>
            </div>
        </div>
        <!-- <div v-if="isParticipant" class="kind"><SelBtn class="status_item" size="big" v-model="status" type="main" :list="statuslist"></SelBtn></div> -->
        <div class="artworks_box">
            <div class="artworks_item" v-for="(item, index) of list" :key="index">
                <Artworks :item="item" :isParticipant="true" :showHead="false" :showBottom="true" :showCompaign="true" hs="204" :showManage="true" @delArt="delArt(item)"></Artworks>
            </div>
        </div>

        <Model :padding="'24px'" v-model="showUnjoinTip">
            <DelArtTip :id="id" :titleActive="titleActive" @cancel="cancel" slot="main" @complete="$emit('change')" />
        </Model>
    </div>
</template>
<script>
export default {
    props: {
        // 是 brand 还是 Participant
        isParticipant: {
            type: Boolean,
            default: false,
        },
        list: {
            type: Array,
            default: () => {
                return []
            },
        },
    },
    data() {
        return {
            showUnjoinTip: false,
            id: '',
            titleActive: '',

            viewEle: {
                price: false,
                status: true,
                play: false,
            },
            source: {
                artworkTitle: '',
                orderByColumn: '',
            },
            status: '1',
            sortlist: [
                {
                    lable: this.langJson('Sort By'),
                    value: '',
                },
                {
                    lable: this.langJson('Recently created'),
                    value: 'createTime',
                },
                {
                    lable: this.langJson('Number of votes'),
                    value: 'voteNum',
                },
            ],
            statuslist: [
                {
                    lable: 'Submitted for campaign',
                    value: '1',
                },
                {
                    lable: 'Drafts',
                    value: '2',
                },
            ],
        }
    },
    watch: {
        source: {
            handler(n) {
                this.$emit('change', n)
            },
            deep: true,
        },
    },
    methods: {
        cancel(close) {
            console.log('close', close)
            this.showUnjoinTip = close
        },
        delArt(item) {
            console.log('退出活动 确认弹框', item)
            this.id = item.id
            this.titleActive = item.campaignName
            this.showUnjoinTip = true
        },
    },
}
</script>
<style lang="scss" scoped>
.collected {
}
.search_item {
    .search_main {
        .sort {
        }
        .search {
            background-color: var(--color_white);
            border-radius: var(--nft_select_border_radius);
            /* border: 1px solid var(--border_color); */
        }
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    padding-top: 32px;
    width: 100%;
    border-radius: 12px;
}
.artworks_box {
    margin-top: 32px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 32px;
    .artworks_item {
        max-width: 296px;
        width: 100%;

        background: var(--color_white);
        box-shadow: 4px 8px 24px rgba(187, 196, 221, 0.08);
        border-radius: 16px;
    }
}
.kind {
    margin-top: 32px;
    margin-bottom: 32px;
}
@media only screen and (max-width: 1080px) {
    .kind {
        margin-top: 20px;
        margin-bottom: 24px;
    }
    .artworks_box {
        margin-top: 24px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 16px;
        .artworks_item {
            max-width: 296px;
            width: 100%;

            background: var(--color_white);
            box-shadow: 4px 8px 24px rgba(187, 196, 221, 0.08);
            border-radius: 16px;
        }
    }
    .artworks_item {
        max-width: 100% !important;
        /* flex: 1; */
    }
}
</style>
